import * as React from 'react';

import { cn } from '@/utils/shad';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, invalid, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-base border border-input bg-transparent px-2 py-1.5 text-sm shadow-xs transition-colors file:font-medium placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        invalid && 'border-negative/60 ring-1 ring-negative/60',
        // remove clear button when "search"
        type === 'search' && ['[&::-webkit-search-cancel-button]:appearance-none'],
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
